// src/plugins/sdk/useReviews.ts — permission-checked reviews access.
import { useEffect, useState, useCallback } from 'react';
import { usePluginId } from './PluginContext';
import { requirePermission } from '../permissions';
import { supabase } from '../../supabase';
import { useSession } from '../../auth/hooks';
export function useReviews(opts = {}) {
    const pluginId = usePluginId();
    requirePermission(pluginId, 'read:reviews');
    const { user } = useSession();
    const [orgId, setOrgId] = useState(null);
    const [rows, setRows] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!user)
            return;
        supabase.from('memberships').select('org_id').eq('user_id', user.id).limit(1).maybeSingle()
            .then(({ data }) => setOrgId((data?.org_id) ?? null));
    }, [user]);
    const refresh = useCallback(async () => {
        if (!orgId)
            return;
        let q = supabase.from('reviews').select('*').eq('org_id', orgId)
            .order('posted_at', { ascending: false }).limit(opts.limit ?? 100);
        if (typeof opts.minRating === 'number')
            q = q.gte('rating', opts.minRating);
        const { data, error: err } = await q;
        if (err) {
            setError(err.message);
            return;
        }
        setRows((data ?? []));
    }, [orgId, opts.limit, opts.minRating]);
    useEffect(() => { void refresh(); }, [refresh]);
    return { reviews: rows, orgId, error, refresh };
}
/** Write-side helper — requires write:reviews. */
export function useReplyToReview() {
    const pluginId = usePluginId();
    return async (reviewId, text) => {
        requirePermission(pluginId, 'write:reviews');
        const { error } = await supabase.from('reviews')
            .update({ response_body: text })
            .eq('id', reviewId);
        if (error)
            throw error;
    };
}
